module.exports = __webpack_public_path__ + "static/media/spot17.ef02e79f.webp";